import { render, staticRenderFns } from "./DispositionPopup.vue?vue&type=template&id=b31e1588&"
import script from "./DispositionPopup.vue?vue&type=script&lang=js&"
export * from "./DispositionPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DispositionPopup.vue"
export default component.exports